export default __webpack_public_path__ + "static/media/suv_car_category.e0551cb9.png";